<template lang="pug">
.re-registration(:class="getComponentClasses()")
  .re-registration-box
    .re-container-form(v-if="showForm")
      .re-form-head
        h2.box-form-title(v-if="showTitle") {{ title }}
        p.box-form-head-message(v-if="showNotice" v-html="notice")
        .re-login-plug
            .login-container {{ $$t('login.label') }} 
                router-link(:to="{ name: $$s('login.route') }") {{ $$t('login.link') }}
        p.box-form-head-error(v-show="!!formErrorMessage" v-html="formErrorMessage")
      .re-form-body
        .registration-inputs-box
          .re-inp-box.re-inp-box--with-icon
            re-input(
              v-model.trim="$v.fields.email.$model"
              v-bind="getFieldProps('email', {type: 'email', defaults: {label: 'Email'}})"
            )
            .re-inp-box__icon
              img(:src="`${baseUri}/images/client/lairdnd/input-icon-envelope.svg`")
          .re-inp-box.re-inp-box--with-icon
            re-input(
              v-model="$v.fields.password.$model"
              v-bind="getFieldProps('password', {type: 'password'})"
              :type="showPassword ? 'text' : 'password'"
            )
            re-input-eye-icon(v-model="showPassword")
          .re-inp-box.re-input-box--flex
            re-checkbox(
              v-model.trim="$v.fields.terms.$model"
              v-bind="getFieldProps('terms')"
            )
              span {{ $$t('form.fields.terms.urls.general') }}
              a.terms-link(:href="$$s('form.fields.terms.urls.terms.url')" target="_blank") {{ $$t('form.fields.terms.urls.terms') }}
              span {{ $$t('form.fields.terms.urls.and') }}
              a.privacy-link(:href="$$s('form.fields.terms.urls.privacy.url')" target="_blank") {{ $$t('form.fields.terms.urls.privacy') }}
        .re-submit-button-container(v-show="!hideActions")
          re-button.btn-primary.btn-lg.re-submit-button(
            @click="initRegistration" 
            :classes="submitButtonClasses"
            :loading="isPromising"
            :tabindex="getMaxFieldOrder()"
          ) {{ submitButtonTitle }}
    .re-account-created(v-if="showConfirmation")
      .re-account-created__icon
        img(:src="`${baseUri}/images/client/lairdnd/registration-success.jpg`" alt="")
      .re-account-created__title Success!
      .re-account-created__message Verification link has been sent to your email.

</template>

<script>
import ReRegistration from 'utils/vue/components/complex/user/re-registration/script.js'

export default {
    name: 'lairdnd-registration',

    mixins: [
        ReRegistration,
    ],

    data() { return {
        showPassword: false,
    }},
}
</script>
